import { render } from "./locale-switcher.vue?vue&type=template&id=5ce263fa&scoped=true"
import script from "./locale-switcher.vue?vue&type=script&lang=js"
export * from "./locale-switcher.vue?vue&type=script&lang=js"

import "./locale-switcher.vue?vue&type=style&index=0&id=5ce263fa&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ce263fa"]])

export default __exports__